// note: generals
import * as React from "react";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// note: mui import
import Link from "@mui/material/Link";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Breadcrumbs from "@mui/material/Breadcrumbs";

function capitalizeFirstLetter(word, letter) {
  // note: create a dynamic regex to match the first occurrence of the given letter
  const regex = new RegExp(`^${letter}`, "i"); // note: 'i' for case-insensitive matching
  return word.replace(regex, (match) => match.toUpperCase());
}

export function breadcrumbNameMap({ to, id, detailId }) {
  let detail;

  switch (to) {
    case "/announcement":
      detail = "Announcement";
      break;
    case `/announcement/${id}/${detailId}`:
      detail = `${capitalizeFirstLetter(detailId, detailId[0])}`;
      break;
    case "/document":
      detail = "Document";
      break;
    case "/document/my":
      detail = "My Document";
      break;
    case "/document/create":
      detail = "Create Document";
      break;
    case "/transmittal":
      detail = "Transmittal";
      break;
    case `/transmittal/${id}`:
      detail = `${capitalizeFirstLetter(id, id[0])}`;
      break;
    case `/transmittal/${id}/${detailId}`:
      detail = `${capitalizeFirstLetter(detailId, detailId[0])}`;
      break;
    case `/transmittal/${id}/${detailId}/detail`:
      detail = "Detail";
      break;
    case "/correspondence":
      detail = "Correspondence";
      break;
    case `/correspondence/${id}`:
      detail = `${capitalizeFirstLetter(id, id[0])}`;
      break;
    case `/correspondence/${id}/${detailId}`:
      detail = `${capitalizeFirstLetter(detailId, detailId[0])}`;
      break;
    case `/correspondence/${id}/${detailId}/detail`:
      detail = "Detail";
      break;
    case "/task":
      detail = "Task";
      break;
    case "/task/work-task":
      detail = "Work Task";
      break;
    case "/task/review-task":
      detail = "Review Task";
      break;
    // note: workflow template
    case `/workflow-template`:
      detail = "Workflow Template";
      break;
    case `/workflow-template/${id}`:
      detail = `${capitalizeFirstLetter(id, id[0])}`;
      break;
    case `/task/${id}`:
      detail = `${capitalizeFirstLetter(id, id[0])}`;
      break;
    case `/task/${id}/workflow`:
      detail = "Workflow";
      break;
    case `/task/${id}/workflow/${detailId}`:
      detail = `${capitalizeFirstLetter(detailId, detailId[0])}`;
      break;
    case `/task/${id}/workflow/${detailId}/detail`:
      detail = "Detail";
      break;
    case "/report":
      detail = "Report";
      break;
    case "/master-data":
      detail = "Master Data";
      break;
    case "/master-data/discipline":
      detail = "Discipline";
      break;
    case "/master-data/document-category":
      detail = "Document Category";
      break;
    case "/master-data/level":
      detail = "Level";
      break;
    case "/master-data/location":
      detail = "Location";
      break;
    case "/master-data/project":
      detail = "Project";
      break;
    case "/master-data/document-type":
      detail = "Document Type";
      break;
    case "/setting":
      detail = "Setting";
      break;
    case "/setting/user":
      detail = "User";
      break;
    case "/setting/badge":
      detail = "Badge (New create duration)";
      break;
    case "/setting/company":
      detail = "Company";
      break;
    case "/setting/announcement":
      detail = "Announcement";
      break;
    case "/dashboard":
      detail = "Dashboard";
      break;
    default:
      detail = "";
  }

  return detail;
}

// note: the script does not use temporarily.
// export function ListItemLink(props) {
//   const { to, open, name, id, detailId, ...other } = props;

//   const primary = breadcrumbNameMap({ to, id, detailId });

//   let icon = null;
//   if (open != null) {
//     icon = open ? <ExpandLess /> : <ExpandMore />;
//   }

//   return (
//     <li>
//       <ListItemButton component={RouterLink} to={to} {...other}>
//         <ListItemText primary={primary} />
//         {icon}
//       </ListItemButton>
//     </li>
//   );
// }

function LinkRouter(props) {
  return <Link {...props} component={RouterLink} />;
}

export function Page() {
  const location = useLocation();
  const { id, detailId } = useParams();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const dispatch = useDispatch();

  function handleClickBreadCrumb() {}

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <LinkRouter underline="hover" color="inherit" to="/">
        <Typography variant="subtitle2">Home</Typography>
      </LinkRouter>
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;

        const to = `/${pathnames.slice(0, index + 1).join("/")}`;

        return last ||
          detailId === value ||
          value === pathnames[pathnames.indexOf(id) - 1] ? (
          <Typography
            key={to}
            sx={{ color: "text.primary" }}
            variant="subtitle2"
          >
            {breadcrumbNameMap({ to, id, detailId })}
          </Typography>
        ) : (
          <LinkRouter
            underline="hover"
            color="inherit"
            to={to}
            key={to}
            onClick={handleClickBreadCrumb}
          >
            <Typography
              key={to}
              sx={{ color: "text.primary" }}
              variant="subtitle2"
            >
              {breadcrumbNameMap({ to, id, detailId })}
            </Typography>
          </LinkRouter>
        );
      })}
    </Breadcrumbs>
  );
}

// note: the script does not use temporarily.
// export default function RouterBreadcrumbs() {
//   const [open, setOpen] = React.useState(true);

//   const handleClick = () => {
//     setOpen((prevOpen) => !prevOpen);
//   };

//   return (
//     <MemoryRouter initialEntries={['/inbox']} initialIndex={0}>
//       <Box sx={{ display: 'flex', flexDirection: 'column', width: 360 }}>
//         <Routes>
//           <Route path="*" element={<Page />} />
//         </Routes>
//         <Box
//           sx={{ bgcolor: 'background.paper', mt: 1 }}
//           component="nav"
//           aria-label="mailbox folders"
//         >
//           <List>
//             <ListItemLink to="/inbox" open={open} onClick={handleClick} />
//             <Collapse component="li" in={open} timeout="auto" unmountOnExit>
//               <List disablePadding>
//                 <ListItemLink sx={{ pl: 4 }} to="/inbox/important" />
//               </List>
//             </Collapse>
//             <ListItemLink to="/trash" />
//             <ListItemLink to="/spam" />
//           </List>
//         </Box>
//       </Box>
//     </MemoryRouter>
//   );
// }
